import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "../css/digitalCore.css";

const DigitalCore = ({ digitalCoreData }) => {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    // Run AFTER first paint
    const id = requestAnimationFrame(() => {
      setShowImage(true);
    });

    return () => cancelAnimationFrame(id);
  }, []);

  if (!digitalCoreData) return null;

  const {
    heading,
    paragraph,
    case_studies = [],
    banner_image,
  } = digitalCoreData;

  return (
    <section className="digital-core-container">
      <div className="digital-core-inner">

        {/* LEFT TEXT */}
        <div className="digital-core-text">
          <h1 className="heading">{heading}</h1>
          <p className="secondpara">{paragraph}</p>

          <div className="case-studies">
            {case_studies.map((study, index) => (
              <div key={index}>
                <h6 className="twopara">{study.title}</h6>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT IMAGE (DELAYED) */}
        <div className="digital-core-image-wrapper">
          {showImage && banner_image ? (
            <img
              src={banner_image}
              alt="Digital Core visual"
              className="digital-core-image"
              decoding="async"
            />
          ) : (
            <div className="image-placeholder" />
          )}
        </div>

      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  digitalCoreData: state.digitalCore.data,
});

export default connect(mapStateToProps)(DigitalCore);
